<form [formGroup]="wdForm" *ngIf="totalAccounts >= 1 else noHaveBankAccounts">
  <div class="header">
    <p>Retiro de fondos</p>
    <img (click)="close()" class="my-auto" height="13" src="assets/icon/x.svg" alt="close">
  </div>
  <div class="body">
    <p class="mb-1">Retira tus fondos a una cuenta bancaria.</p>
    <p class="info">¡Importante! Solo puedes realizar dos retiros mensuales (uno cada 24hrs).</p>

    <div>
      <label class="mnf-control-label">Cuenta destino</label>
      <mat-form-field appearance="outline" class="mnf-select mb-2">
        <mat-select disableRipple formControlName="bankAccount">
          <mat-option [value]="ba" *ngFor="let ba of bankAccounts" [title]="ba.alias">
            {{ ba.alias }} - {{ ba.bankName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <label class="mnf-control mb-2">
      <p class="mnf-control-label">Monto</p>
      <div class="d-flex align-items-center">
        <input
          class="mnf-input-form"
          [ngClass]="{ error: control.touched && control.invalid }"
          formControlName="amount"
          currencyMask
          maxlength="18"
          (ngModelChange)="changeAmount()"
          autocomplete="off"
        >
      </div>
      <button
          type="button"
          class="btn-custom-link ms-2 mt-2 mb-4"
          (click)="addAll()">
          Agregar todo
        </button>
    </label>

    <div class="d-flex mb-5">
      <img class="me-2 my-auto" height="12" src="assets/icon/info.svg" alt="">
      <p class="wd-info">Después del retiro, tu saldo será de
        <span class="cl-primary-7">{{ balance - control.value | currency: '$' }}</span></p>
    </div>

    <div class="text-center">
      <button mat-button type="button" [disabled]="this.wdForm.controls['amount'].value > balance" (click)="next()">Retirar</button>
    </div>

  </div>
</form>

<ng-template #noHaveBankAccounts>
  <div class="header">
    <p>Retiro de fondos</p>
    <img (click)="close()" class="my-auto" height="13" src="assets/icon/x.svg" alt="close">
  </div>
  <div class="body">
    <h3 class="text-center fs-24 fw-sbold">¡Asocia una cuenta de Banco!</h3>
    <p class="mt-4 fs-14">
      Para realizar un retiro debes abonar saldo a tu <strong>CLABE STP</strong> desde una cuenta de banco <strong>que esté a tu nombre y automáticamente aparecerá en la lista de tus cuentas asociadas en Monific.</strong>
    </p>
    <p class="mt-3 fs-14">
      Si tú por ejemplo invertiste desde una cuenta bancaria, pero deseas retirarlo a otra cuenta bancaria, debes de abonar saldo desde la cuenta en la que deseas retirar, recordando que las mismas deben estar a tu nombre.
    </p>
    <p class="mt-3 fs-13"><strong>¡Recuerda: máximo 2 retiros mensuales y un retiro diario!</strong></p>
    <p class="mt-3 fs-14">
      En caso de que tu cuenta no se asocie, incluso después de abonar, probablemente un dato de tu perfil está incorrecto y debemos revisarlo para corregirlo y que te permita continuar con el retiro.
    </p>
    <div class="text-center mt-5">
      <button mat-button type="button" (click)="close()">Entendido</button>
    </div>
  </div>
</ng-template>
